<div class="bk-dialog bk-dialog__event">
	<button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

	<h4 mat-dialog-title>
		{{ 'Add' | translate }} {{ 'Commodity' | translate}}
	</h4>

	<div mat-dialog-content>
		<ranch-commodity-type-form
			[ranchGuid]="ranchGuid"
			(onCancel)="closeFinal()"
			(onHide)="hide()"
			(onShow)="show()"
			(formSubmit)="save($event)">
		</ranch-commodity-type-form>
	</div>

	<div mat-dialog-actions
		align="end">
		<button mat-button
			class="bk-button bk-button--medium bk-button--text-only
				bk-dialog__button--secondary"
			(click)="close()">
			{{ 'Cancel' | translate }}
		</button>

		<button mat-button
			class="bk-button bk-button--medium"
			(click)="commodityTypeForm.submit()"
			[disabled]="!commodityTypeForm || !commodityTypeForm.isFormValid">
			{{ 'Save' | translate }}
		</button>
	</div>
</div>
